import PropTypes from 'prop-types';
import { useState } from 'react';
import { Col, Row } from '@arkestro/arkestro-design-system';
import ScreenIndicators from './ScreenIndicators';
import style from './Carousel.module.scss';

/** @type {(...args: any[]) => void} */
const noop = () => {};

const Carousel = ({ steps, onChange = noop }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const stepCount = steps.length;
  const step = steps[currentStep];

  const setStep = stepNum => {
    setCurrentStep(stepNum);

    if (onChange) onChange(stepNum, stepCount);
  };

  return (
    <div className={style.wrapper}>
      <Row>
        <Col sm={12}>
          <div className={style.textAndNavWrapper}>
            <div className={style.textWrapper}>
              <div className={style.title}>{step.title}</div>
              <div className={style.subtitle}>{step.text}</div>
            </div>
            <div className={style.ScreenIndicators}>
              <ScreenIndicators activeStep={currentStep} setCurrentStep={setStep} stepCount={stepCount} />
            </div>
          </div>
        </Col>
        <Col sm={12}>
          <div className={style.imageWrapper}>
            {step.image && <img alt={step.title} src={step.image} />}
          </div>
        </Col>
      </Row>
    </div>
  );
};

Carousel.propTypes = {
  onChange: PropTypes.func,
  steps: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default Carousel;
